import styled, { css } from 'styled-components';

export const ToolButtonsContainer = styled.div`
  position: fixed;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
`;

export const ToolButtonLabel = styled.div`
  display: none;
  position: absolute;
  right: 66px;
  top: 50%;
  transform: translateY(-50%);
  padding: 5px 10px;
  background-color: ${({ theme }) => theme.colors.charade};
  border-radius: 2px;
  color: ${({ theme }) => theme.colors.white};
  white-space: nowrap;
`;

const ToolButton = css`
  display: ${({ isVisible }) => (isVisible ? 'block' : 'none')};
  position: relative;
  height: 60px;
  width: 60px;
  margin: 0 0 10px;
  border-radius: 4px;
  padding: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  .hv-svg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;

    rect {
      fill: ${({ isActive, theme }) =>
        isActive ? theme.colors.activeBlue : theme.colors.defaultActionBlue};
    }

    /*
      Fixes sticky hover for touch devices
      https://stackoverflow.com/questions/17233804/how-to-prevent-sticky-hover-effects-for-buttons-on-touch-devices
    */
    @media (hover: hover) {
      &:hover {
        rect {
          fill: ${({ theme }) => theme.colors.defaultActionDarkBlue};
        }

        ${ToolButtonLabel} {
          display: block;
        }
      }
    }

    ${({ disabled, theme }) =>
      disabled
        ? css`
            rect {
              fill: ${theme.colors.white};
            }
            path {
              fill: ${theme.colors.lightGrayFour};
            }

            &:hover {
              rect {
                fill: ${theme.colors.white};
              }
            }
          `
        : ''}
  }
`;

export const SplitToolButton = styled.button`
  ${ToolButton}
  padding-bottom: 10px;
`;

export const SelectToolButton = styled.button`
  ${ToolButton}
`;
